<div class="adtabcontent">
  <app-column-header [headerData]="headerData"></app-column-header>
  <div class="admcard" *ngFor="let data of menuWisePageListdata">
    <!-- <div class="admhead"> -->
      <div class="admsubtitle">
        {{data.parent_menu_name}}
    </div>
    <!-- </div> -->
    <div class="admcontent rowlist">
      <ul class="admitemlist fourcolum">
        <li *ngFor="let data1 of data.child">
          <span (click)="viewPage(data1)">
            <svg class="icon">
              <use [attr.xlink:href]="srcPath.menuIconPath+data1.gstibo_icon"></use>
            </svg>
          </span>
          <a (click)="viewPage(data1)"  class="cursrponts">
            {{data1.gstibo_page_name}}
          </a>
          <div class="actions">
            <button class="edit" (click)="editPage(data1)">
              <svg>
                <use [attr.xlink:href]="adminMenuIcon+'newedit'"></use>
              </svg>
            </button>
            <button class="delete" (click)="deletePage(data1.gstibo_page_id,data1.gstibo_page_name)">
              <svg>
                <use [attr.xlink:href]="adminMenuIcon+'trash'"></use>
              </svg>
            </button>

          </div>
          <!-- <figure class="{{data1.gstibo_menu_style}}" (click)="viewPage(data1)">
        <svg class="icon">
          <use [attr.xlink:href]="srcPath.menuIconPath+data1.gstibo_icon"></use>
        </svg>
      </figure> -->
          <!-- <figcaption (click)="viewPage(data1)">
        {{data1.gstibo_page_name}}</figcaption> -->
          <!-- <div class="editApp-pages">
        <a (click)="editPage(data1)">Edit</a>
        <a (click)="deletePage(data1.gstibo_page_id,data1.gstibo_page_name)">Delete</a>
      </div> -->
        </li>
      </ul>
    </div>

  </div>
</div>




















<!-- 
<div class="iconBlock">
    <div class="appNames" *ngFor="let data of pageListData">
        <h4 (click)="viewPage(data)">{{data.gstibo_page_name}}</h4>
        <p>
            <a (click)="editPage(data)">Edit</a>
            |
            <a (click)="deletePage(data.gstibo_page_id,data.gstibo_page_name)">Delete</a>
        </p>
    </div>
</div> -->

<!-- <webcam [trigger]="triggerObservable" style="width: 100px; height: 100px;" (imageCapture)="handleImage($event)" (initError)="handleInitError($event)">

</webcam>
<br />
<button id="snapshotBtn" style="display: none;" (click)="triggerSnapshot();">Click</button>
<div class="snapshot" *ngIf="webcamImage">
  <h2>Nice one</h2>
  <img [src]="webcamImage.imageAsDataUrl" />
</div> -->


<div style="display: none; ">
  <div style="text-align:center; ">
    <h1>
      Ngx-Webcam Demo
    </h1>


    <div>
      <webcam [height]="500" [width]="500" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
        *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
        [videoOptions]="videoOptions" [imageQuality]="1" (cameraSwitched)="cameraWasSwitched($event)"
        (initError)="handleInitError($event)"></webcam>
      <br />
      <button class="actionBtn" (click)="triggerSnapshot();">Take A Snapshot</button>
      <button class="actionBtn" (click)="toggleWebcam();">Toggle Webcam</button>
      <br />
      <button class="actionBtn" (click)="showNextWebcam(true);" [disabled]="!multipleWebcamsAvailable">Next
        Webcam</button>
      <input id="cameraSwitchCheckbox" type="checkbox" [(ngModel)]="allowCameraSwitch"><label
        for="cameraSwitchCheckbox">Allow Camera Switch</label>
      <br />
      DeviceId: <input id="deviceId" type="text" [(ngModel)]="deviceId" style="width: 500px">
      <button (click)="showNextWebcam(deviceId);">Activate</button>
      <br />
      Preferred facing mode:
      <input type="radio" value="user" name="facingMode" [(ngModel)]="facingMode"> User
      <input type="radio" value="environment" name="facingMode" [(ngModel)]="facingMode"> Environment
      <input type="radio" value="" name="facingMode" [(ngModel)]="facingMode"> No preference
    </div>
  </div>


  <div class="snapshot" *ngIf="webcamImage">
    <h2>Nice one!</h2>
    <img [src]="webcamImage.imageAsDataUrl" />
  </div>


  <h4 *ngIf="errors.length > 0">Messages:</h4>
  <ul *ngFor="let error of errors">
    <li>{{error | json}}</li>
  </ul>


  <h2>Like this project on GitHub:</h2>
  <ul class="links">
    <li>
      <h2><a target="_blank" rel="noopener" href="https://github.com/basst314/ngx-webcam">Ngx-Webcam / GitHub</a></h2>
    </li>
  </ul>
</div>